<template>
  <div class="questions">
    <div class="questionsBox"
         v-loading="pageLoading"
         element-loading-text="预约中"
         element-loading-spinner="el-icon-loading"
    >
      <el-row>
        <el-col :span="20">数据筛选</el-col>
        <el-col :span="4">
          <el-button type="success" round icon="el-icon-check" size="small" @click="searchData">确 认</el-button>
          <el-button type="info" round icon="el-icon-refresh-left" size="small" @click="resetSearch" >重 置</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="filter">
        <el-col :span="6">
          <span class="label">模版名称</span>
          <el-input
            v-model="tableConfig.name"
            placeholder="检查ID或名称"
            style="width: auto"
          ></el-input>
        </el-col>
        <el-col :span="6">
          <span class="label">任务类型</span>
          <el-select v-model="tableConfig.taskType" placeholder="">
            <el-option
              v-for="(item, index) in taskTypeList"
              :key="index"
              :label="item.name"
              :value="item.no"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-divider></el-divider>

      <el-row>
        <el-col :span="22">数据列表</el-col>
        <el-col :span="2">
<!--          <el-button
            plain
            round
            size="small"
            style="color: #67C23A"
            @click="openDownloadList()"
          >
            导出记录
          </el-button>-->
          <el-button
            plain
            round
            icon="el-icon-plus"
            size="small"
            style="color: #67C23A"
            @click="openCreate()"
          >
            新 建
          </el-button>
        </el-col>
      </el-row>

      <el-table
        style="width: 100%; margin-top: 20px"
        fit
        stripe
        :data="tableData"
        v-loading="tableLoading"
        border
      >
        <el-table-column
          prop="id"
          label="序号"
          width="60"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="模版名称"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="taskType"
          label="任务类型"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="startDate"
          label="开始时间"
          width="110"
        >
        </el-table-column>
        <el-table-column
          prop="endDate"
          label="结束时间"
          width="110"
        ></el-table-column>
        <el-table-column
          prop="requiredRoles"
          label="执行角色"
        ></el-table-column>
        <el-table-column
          prop="maxImageCount"
          label="最大上传图片数"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="maxVideoCount"
          label="最大上传视频数"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
        ></el-table-column>
        <el-table-column
          prop="taskCompletionSituation"
          label="任务完成情况"
        ></el-table-column>
        <el-table-column label="操作" width="400">
          <template slot-scope="scope">
            <el-button type="text" style="color: #606266" icon="el-icon-download" size="mini" @click="openBook(scope.row.id)">
              预约下载
            </el-button>
            <el-button type="text" style="color: #606266" icon="el-icon-download" size="mini" @click="openDownloadList(scope.row.id)">
              导出记录
            </el-button>
            <el-button type="text" style="color: #606266" icon="el-icon-download" size="mini" @click="openExcel(scope.row.id)">
              导出完成情况
            </el-button>
            <el-button type="text" style="color: #606266" icon="el-icon-edit" size="mini" @click="openEdit(scope.row.id)"
            >编辑</el-button
            >
            <el-button type="text" style="color: #606266" icon="el-icon-delete" size="mini" @click="delQuestion(scope.row.id)"
            >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <footer>
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="currentChange"
          :current-page="tableConfig.current"
          :total="total"
        ></el-pagination>
      </footer>
    </div>
    <el-dialog
      title="预约下载"
      :visible.sync="dateDialog"
      width="40%"
      center>
      <el-form :model="dateForm">
        <el-form-item label="开始日期" >
          <el-date-picker
            v-model="dateForm.startDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期" >
          <el-date-picker
            v-model="dateForm.endDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog()">取 消</el-button>
        <el-button type="primary" @click="confirmBook">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="导出完成情况"
      :visible.sync="excelDialog"
      width="40%"
      center>
      <el-form :model="dateForm">
        <el-form-item label="开始日期" >
          <el-date-picker
            v-model="dateForm.startDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期" >
          <el-date-picker
            v-model="dateForm.endDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog()">取 消</el-button>
        <el-button type="primary" @click="downloadExcel">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="导出记录"
      :visible.sync="downloadDialog"
      width="80%"
      center>
      <div class="downloadList">
        <el-table :data="downloadList">
          <el-table-column property="templateName" label="名称" ></el-table-column>
          <el-table-column property="createTime" label="预约时间" ></el-table-column>
          <el-table-column property="startDate" label="开始时间" ></el-table-column>
          <el-table-column property="endDate" label="结束时间" ></el-table-column>
          <el-table-column property="statusDesc" label="状态" ></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.status === 2"
                type="text"
                size="mini"
                @click="downloadData(scope.row.downloadUrls)"
              >下载</el-button>
            </template>
          </el-table-column>
        </el-table>
        <footer>
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="downloadCurrentChange"
            :current-page="downloadTableConfig.current"
            :total="downloadTotal"
          ></el-pagination>
        </footer>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDownload()">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import md5 from "md5";

export default {
  name: "Questions",
  data() {
    return {
      pageLoading: false,
      name: '',
      taskType: '',
      startDate: '',
      endDate: '',
      requires: '',
      requiredRoles: '',
      maxImageCount: '',
      maxVideoCount: '',
      remark: '',
      taskTypeList: [
        {
          name: '穿搭',
          no: 'OUTFIT'
        },
        {
          name: '例会',
          no: 'MEETING'
        },
      ],
      checkOptionList: [],
      tableData: [], // 列表
      total: 10, // 总数量
      tableConfig: {
        size: 10, // 每页数量
        current: this.$route.query.current*1 || 1, // 当前页码
        name:'',  // 题目
        taskType: null,  //分类
      },
      tableLoading: false,
      downloadDialog: false,
      progress: 1, //1预约下载 2正在处理 3下载
      queryProcess: null, //轮询预约下载进度
      downloadList: [], //下载列表
      downloadTotal: 0, // 下载列表总数量
      downloadTableConfig: {
        size: 10, // 每页数量
        current: 1, // 当前页码
      },
      dateDialog: false,
      excelDialog: false,
      dateForm: {
        startDate: '',
        endDate: ''
      },
      initDateForm: {
        startDate: '',
        endDate: ''
      },
      currentTemplateId: ''
    }
  },
  computed: {
    // checkItemList: ({ $store: { getters } }) => getters.checkItemList // 检查项
  },
  mounted() {
    this.getData();
    this.$store.dispatch("getStoreCheckItems"); // 检查项
  },
  methods: {
    searchData() {
      this.tableConfig.current = 1;
      this.getData();
    },
    async getData() {
      // 获取列表
      this.tableLoading = true;
      let res = await axios.post(retailinkUrl+"/taskTemplate/list", this.tableConfig);
      res = res.data;
      if (res.code === 200) {
        this.tableData = res.data.records || [];
        this.total = res.data.total;
      }
      this.tableLoading = false;
    },
    resetSearch(){
      this.tableConfig.name = '';
      this.tableConfig.taskType = '';
    },
    currentChange(index) {
      // 分页
      this.tableConfig.current = index;
      this.getData();
    },
    openCreate() {
      this.$router.push({ path: '/template/taskTemplateEdit' });
    },
    openEdit(id) {
      this.$router.push({ path: '/template/taskTemplateEdit', query: { id, current: this.tableConfig.current } });
    },

    // 预约下载
    openBook(id) {
      this.dateDialog = true
      this.dateForm = _.cloneDeep(this.initDateForm)
      this.currentTemplateId = id
    },

    // 导出完成情况
    openExcel(id) {
      this.excelDialog = true
      this.dateForm = _.cloneDeep(this.initDateForm)
      this.currentTemplateId = id
    },

    // 关闭弹窗
    closeDialog() {
      this.dateDialog = false
      this.excelDialog = false
      this.dateForm = _.cloneDeep(this.initDateForm)
      this.currentTemplateId = ''
    },
    // 预约下载
    async confirmBook() {
      this.dateDialog = false
      this.pageLoading = true
      try {
        // 导出
        let params = {
          startDate: this.dateForm.startDate,
          endDate: this.dateForm.endDate,
          templateId: this.currentTemplateId
        }
        let res = await axios.post(retailinkUrl + "/taskTemplate/export/apply", params);
        if (res.data.code === 200) {
          // 正在处理...
          this.$message.success(res.data.message)
          this.dateForm = _.cloneDeep(this.initDateForm)
          this.currentTemplateId = ''
        }
        else {
          console.log('预约下载失败')
          // this.$message.error(res.data.msg);
        }
      } catch(e) {
      } finally {
        this.pageLoading = false
      }
    },

    // 打开导出记录
    async openDownloadList(id) {
      this.downloadDialog = true
      let res = await axios.post(
        retailinkUrl + "/taskTemplate/export/list",
        _.assign({ templateId: id }, this.downloadTableConfig)
      );
      if (res.data.code === 200) {
        console.log('res.data', res.data)
        this.downloadList = res.data.data.records
        this.downloadTotal = res.data.data.total
      }
    },

    // 下载具体的文件
    downloadData(urls) {
      _.each(urls, (file) => {
        window.open(file)
      })
    },

    downloadCurrentChange(index) {
      // 分页
      this.downloadTableConfig.current = index;
      this.openDownloadList()
    },

    // 关闭导出日记
    closeDownload() {
      this.downloadDialog = false
      this.downloadList = []
      this.downloadTotal = 0
    },

    // 导出完成情况
    async downloadExcel() {
      let params = {
        startDate: this.dateForm.startDate,
        endDate: this.dateForm.endDate,
        templateId: this.currentTemplateId
      }
      let { data, fileName } = await this.$tool.exportFile({
        method: "post",
        url: retailinkUrl + "/taskTemplate/instances/export",
        data: params
      });
      if (!!data) {
        this.closeDialog()
      }
    },
    async delQuestion(id){
      await this.$confirm('确定删除吗?', '提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.post(retailinkUrl+"/taskTemplate/delete/"+id).
        then((response) => {
          if (response.data.code === 200) {
            this.getData()
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }else {
            this.$message({
              type: 'warning',
              message: response.data.message
            });
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      })
    },
  }
};
</script>
<style lang="sass" scoped>
.questions
  min-width: 1050px
  .questionsBox
    padding: 20px
    .title
      color: #6F6F6F
      font-size: 26px
      font-weight: 600
      letter-spacing: 2px
      text-align: center
      margin-bottom: 30px
    .filter
      margin-top: 30px
    .label
      font-size: 14px
      color: #606266
    .table-container
      margin-top: 20px
  footer
    padding-top: 20px
    text-align: right
</style>



// WEBPACK FOOTER //
// src/pages/template/taskTemplate.vue